module.exports = __webpack_public_path__ + "icon_do-a1e80acefcb2954bf4105e5862655f23.png";